"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _material = require("@mui/material");

var TableCellTooltip = function TableCellTooltip(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$lengthToShow = _ref.lengthToShow,
      lengthToShow = _ref$lengthToShow === void 0 ? 24 : _ref$lengthToShow,
      renderLabel = _ref.renderLabel,
      isValueLink = _ref.isValueLink,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title", "lengthToShow", "renderLabel", "isValueLink"]);
  var showTooltip = (0, _react.useMemo)(function () {
    return typeof title === 'string' ? title.length > lengthToShow : true;
  }, [title, lengthToShow]);
  var label = (0, _react.useMemo)(function () {
    var renderedLabel = renderLabel ? renderLabel() : title;
    var isRenderedLabelEmpty = renderedLabel === '' || R.isNil(renderedLabel);

    if (isValueLink && !isRenderedLabelEmpty && typeof title === 'string') {
      return /*#__PURE__*/_react["default"].createElement("a", {
        rel: "noreferrer noopener",
        className: "H3-Chambray",
        target: "_blank",
        href: title
      }, renderedLabel);
    }

    return isRenderedLabelEmpty ? '-' : renderedLabel;
  }, [isValueLink, renderLabel, title]);
  return showTooltip ? /*#__PURE__*/_react["default"].createElement(_material.Tooltip, (0, _extends2["default"])({
    title: title,
    placement: "top"
  }, props), /*#__PURE__*/_react["default"].createElement("span", null, label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label);
};

var _default = /*#__PURE__*/(0, _react.memo)(TableCellTooltip);

exports["default"] = _default;